export default [
    [
        { "name": "افغانستان", "code": "af", "název": "Afghánistán", "locale": "fa-AF" },
        { "name": "Shqipëria", "code": "al", "název": "Albánie", "locale": "sq-AL" },
        { "name": "الجزائر", "code": "dz", "název": "Alžírsko", "locale": "ar-DZ" },
        { "name": "American Samoa", "code": "as", "název": "Americká Samoa", "locale": "en-AS" },
        { "name": "Andorra", "code": "ad", "název": "Andorra", "locale": "ca-AD" },
        { "name": "Angola", "code": "ao", "název": "Angola", "locale": "pt-AO" },
        { "name": "Anguilla", "code": "ai", "název": "Anguilla", "locale": "en-AI" },
        { "name": "Antarctica", "code": "aq", "název": "Antarktida", "locale": "en-AQ" },
        { "name": "Antigua and Barbuda", "code": "ag", "název": "Antigua a Barbuda", "locale": "en-AG" },
        { "name": "Argentina", "code": "ar", "název": "Argentina", "locale": "es-AR" },
        { "name": "Հայաստան", "code": "am", "název": "Arménie", "locale": "hy-AM" },
        { "name": "Aruba", "code": "aw", "název": "Aruba", "locale": "nl-AW" },
        { "name": "Australia", "code": "au", "název": "Austrálie", "locale": "en-AU" },
        { "name": "Österreich", "code": "at", "název": "Rakousko", "locale": "de-AT" },
        { "name": "Azərbaycan", "code": "az", "název": "Ázerbájdžán", "locale": "az-AZ" },
        { "name": "Bahamas", "code": "bs", "název": "Bahamy", "locale": "en-BS" },
        { "name": "البحرين", "code": "bh", "název": "Bahrajn", "locale": "ar-BH" },
        { "name": "বাংলাদেশ", "code": "bd", "název": "Bangladéš", "locale": "bn-BD" },
        { "name": "Barbados", "code": "bb", "název": "Barbados", "locale": "en-BB" },
        { "name": "Беларусь", "code": "by", "název": "Bělorusko", "locale": "be-BY" },
        { "name": "België/Belgique", "code": "be", "název": "Belgie", "locale": "nl-BE" },
        { "name": "Belize", "code": "bz", "název": "Belize", "locale": "en-BZ" },
        { "name": "Bénin", "code": "bj", "název": "Benin", "locale": "fr-BJ" },
        { "name": "Bermuda", "code": "bm", "název": "Bermudy", "locale": "en-BM" },
        { "name": "འབྲུག་ཡུལ", "code": "bt", "název": "Bhútán", "locale": "dz-BT" },
        { "name": "Bolivia", "code": "bo", "název": "Bolívie", "locale": "es-BO" },
        { "name": "Bosna i Hercegovina", "code": "ba", "název": "Bosna a Hercegovina", "locale": "bs-BA" },
        { "name": "Botswana", "code": "bw", "název": "Botswana", "locale": "en-BW" },
        { "name": "Brasil", "code": "br", "název": "Brazílie", "locale": "pt-BR" },
        { "name": "Negara Brunei Darussalam", "code": "bn", "název": "Brunej", "locale": "ms-BN" },
        { "name": "България", "code": "bg", "název": "Bulharsko", "locale": "bg-BG" },
        { "name": "Burkina Faso", "code": "bf", "název": "Burkina Faso", "locale": "fr-BF" },
        { "name": "Burundi", "code": "bi", "název": "Burundi", "locale": "fr-BI" },
        { "name": "Cabo Verde", "code": "cv", "název": "Kapverdy", "locale": "pt-CV" },
        { "name": "កម្ពុជា", "code": "kh", "název": "Kambodža", "locale": "km-KH" },
        { "name": "Cameroun", "code": "cm", "název": "Kamerun", "locale": "fr-CM" },
        { "name": "Canada", "code": "ca", "název": "Kanada", "locale": "en-CA" },
        { "name": "Cayman Islands", "code": "ky", "název": "Kajmanské ostrovy", "locale": "en-KY" },
        { "name": "République centrafricaine", "code": "cf", "název": "Středoafrická republika", "locale": "fr-CF" },
        { "name": "تشاد", "code": "td", "název": "Čad", "locale": "ar-TD" },
        { "name": "Chile", "code": "cl", "název": "Chile", "locale": "es-CL" },
        { "name": "中国", "code": "cn", "název": "Čína", "locale": "zh-CN" },
        { "name": "Colombia", "code": "co", "název": "Kolumbie", "locale": "es-CO" },
        { "name": "جزر القمر", "code": "km", "název": "Komory", "locale": "ar-KM" },
        { "name": "Costa Rica", "code": "cr", "název": "Kostarika", "locale": "es-CR" },
        { "name": "Hrvatska", "code": "hr", "název": "Chorvatsko", "locale": "hr-HR" },
        { "name": "Cuba", "code": "cu", "název": "Kuba", "locale": "es-CU" },
        { "name": "Κύπρος", "code": "cy", "název": "Kypr", "locale": "el-CY" },
        { "name": "Česko", "code": "cz", "název": "Česko", "locale": "cs-CZ" },
        { "name": "Danmark", "code": "dk", "název": "Dánsko", "locale": "da-DK" },
        { "name": "جيبوتي", "code": "dj", "název": "Džibutsko", "locale": "ar-DJ" },
        { "name": "Dominica", "code": "dm", "název": "Dominika", "locale": "en-DM" },
        { "name": "República Dominicana", "code": "do", "název": "Dominikánská republika", "locale": "es-DO" },
        { "name": "Ecuador", "code": "ec", "název": "Ekvádor", "locale": "es-EC" },
        { "name": "مصر", "code": "eg", "název": "Egypt", "locale": "ar-EG" },
        { "name": "El Salvador", "code": "sv", "název": "Salvador", "locale": "es-SV" },
        { "name": "Guinea Ecuatorial", "code": "gq", "název": "Rovníková Guinea", "locale": "es-GQ" },
        { "name": "ኤርትራ", "code": "er", "název": "Eritrea", "locale": "ti-ER" },
        { "name": "Eesti", "code": "ee", "název": "Estonsko", "locale": "et-EE" },
        { "name": "ኢትዮጵያ", "code": "et", "název": "Etiopie", "locale": "am-ET" },
        { "name": "Suomi", "code": "fi", "název": "Finsko", "locale": "fi-FI" },
        { "name": "France", "code": "fr", "název": "Francie", "locale": "fr-FR" },
        { "name": "Deutschland", "code": "de", "název": "Německo", "locale": "de-DE" },
        { "name": "Ghana", "code": "gh", "název": "Ghana", "locale": "en-GH" },
        { "name": "Ελλάδα", "code": "gr", "název": "Řecko", "locale": "el-GR" },
        { "name": "Honduras", "code": "hn", "název": "Honduras", "locale": "es-HN" },
        { "name": "Magyarország", "code": "hu", "název": "Maďarsko", "locale": "hu-HU" },
        { "name": "Ísland", "code": "is", "název": "Island", "locale": "is-IS" },
        { "name": "भारत", "code": "in", "název": "Indie", "locale": "hi-IN" },
        { "name": "Indonesia", "code": "id", "název": "Indonésie", "locale": "id-ID" },
        { "name": "ایران", "code": "ir", "název": "Írán", "locale": "fa-IR" },
        { "name": "العراق", "code": "iq", "název": "Irák", "locale": "ar-IQ" },
        { "name": "Éire", "code": "ie", "název": "Irsko", "locale": "en-IE" },
        { "name": "ישראל", "code": "il", "název": "Izrael", "locale": "he-IL" },
        { "name": "Italia", "code": "it", "název": "Itálie", "locale": "it-IT" },
        { "name": "日本", "code": "jp", "název": "Japonsko", "locale": "ja-JP" },
        { "name": "الأردن", "code": "jo", "název": "Jordánsko", "locale": "ar-JO" },
        { "name": "Қазақстан", "code": "kz", "název": "Kazachstán", "locale": "kk-KZ" },
        { "name": "Kenya", "code": "ke", "název": "Keňa", "locale": "en-KE" },
        { "name": "الكويت", "code": "kw", "název": "Kuvajt", "locale": "ar-KW" },
        { "name": "Latvija", "code": "lv", "název": "Lotyšsko", "locale": "lv-LV" },
        { "name": "لبنان", "code": "lb", "název": "Libanon", "locale": "ar-LB" },
        { "name": "México", "code": "mx", "název": "Mexiko", "locale": "es-MX" },
        { "name": "المغرب", "code": "ma", "název": "Maroko", "locale": "ar-MA" },
        { "name": "Nederland", "code": "nl", "název": "Nizozemsko", "locale": "nl-NL" },
        { "name": "New Zealand", "code": "nz", "název": "Nový Zéland", "locale": "en-NZ" },
        { "name": "Nigeria", "code": "ng", "název": "Nigérie", "locale": "en-NG" },
        { "name": "Norge", "code": "no", "název": "Norsko", "locale": "nb-NO" },
        { "name": "Perú", "code": "pe", "název": "Peru", "locale": "es-PE" },
        { "name": "Polska", "code": "pl", "název": "Polsko", "locale": "pl-PL" },
        { "name": "Portugal", "code": "pt", "název": "Portugalsko", "locale": "pt-PT" },
        { "name": "Россия", "code": "ru", "název": "Rusko", "locale": "ru-RU" },
        { "name": "المملكة العربية السعودية", "code": "sa", "název": "Saúdská Arábie", "locale": "ar-SA" },
        { "name": "España", "code": "es", "název": "Španělsko", "locale": "es-ES" },
        { "name": "Sverige", "code": "se", "název": "Švédsko", "locale": "sv-SE" },
        { "name": "Schweiz/Suisse/Svizzera", "code": "ch", "název": "Švýcarsko", "locale": "de-CH" },
        { "name": "Türkiye", "code": "tr", "název": "Turecko", "locale": "tr-TR" },
        { "name": "Україна", "code": "ua", "název": "Ukrajina", "locale": "uk-UA" },
        { "name": "United Kingdom", "code": "gb", "název": "Spojené království", "locale": "en-GB" },
        { "name": "United States", "code": "us", "název": "Spojené státy americké", "locale": "en-US" }
      ]
    // { "name":  "افغانستان", "code": "af", "název": "Afghánistán" },
    // { "name": "Albania", "code": "al", "název": "Albánie" },
    // { "name": "Argelia", "code": "dz", "název": "Alžírsko" },
    // { "name": "Samoa Americana", "code": "as", "název": "Americká Samoa" },
    // { "name": "Andorra", "code": "ad", "název": "Andorra" },
    // { "name": "Angola", "code": "ao", "název": "Angola" },
    // { "name": "Anguila", "code": "ai", "název": "Anguilla" },
    // { "name": "Antártida", "code": "aq", "název": "Antarktida" },
    // { "name": "Antigua y Barbuda", "code": "ag", "název": "Antigua a Barbuda" },
    // { "name": "Argentina", "code": "ar", "název": "Argentina" },
    // { "name": "Armenia", "code": "am", "název": "Arménie" },
    // { "name": "Aruba", "code": "aw", "název": "Aruba" },
    // { "name": "Australia", "code": "au", "název": "Austrálie" },
    // { "name": "Austria", "code": "at", "název": "Rakousko" },
    // { "name": "Azerbaiyán", "code": "az", "název": "Ázerbájdžán" },
    // { "name": "Bahamas", "code": "bs", "název": "Bahamy" },
    // { "name": "Bahrein", "code": "bh", "název": "Bahrajn" },
    // { "name": "Bangladesh", "code": "bd", "název": "Bangladéš" },
    // { "name": "Barbados", "code": "bb", "název": "Barbados" },
    // { "name": "Bielorrusia", "code": "by", "název": "Bělorusko" },
    // { "name": "Bélgica", "code": "be", "název": "Belgie" },
    // { "name": "Belice", "code": "bz", "název": "Belize" },
    // { "name": "Benin", "code": "bj", "název": "Benin" },
    // { "name": "Bermudas", "code": "bm", "název": "Bermudy" },
    // { "name": "Bután", "code": "bt", "název": "Bhútán" },
    // { "name": "Bolivia", "code": "bo", "název": "Bolívie" },
    // { "name": "Bosnia y Herzegovina", "code": "ba", "název": "Bosna a Hercegovina" },
    // { "name": "Botsuana", "code": "bw", "název": "Botswana" },
    // { "name": "Brasil", "code": "br", "název": "Brazílie" },
    // { "name": "Brunéi", "code": "bn", "název": "Brunej" },
    // { "name": "Bulgaria", "code": "bg", "název": "Bulharsko" },
    // { "name": "Burkina Faso", "code": "bf", "název": "Burkina Faso" },
    // { "name": "Burundi", "code": "bi", "název": "Burundi" },
    // { "name": "Cabo Verde", "code": "cv", "název": "Kapverdy" },
    // { "name": "Camboya", "code": "kh", "název": "Kambodža" },
    // { "name": "Camerún", "code": "cm", "název": "Kamerun" },
    // { "name": "Canadá", "code": "ca", "název": "Kanada" },
    // { "name": "Islas Caimán", "code": "ky", "název": "Kajmanské ostrovy" },
    // { "name": "República Centroafricana", "code": "cf", "název": "Středoafrická republika" },
    // { "name": "Chad", "code": "td", "název": "Čad" },
    // { "name": "Chile", "code": "cl", "název": "Chile" },
    // { "name": "China", "code": "cn", "název": "Čína" },
    // { "name": "Colombia", "code": "co", "název": "Kolumbie" },
    // { "name": "Comoras", "code": "km", "název": "Komory" },
    // { "name": "Costa Rica", "code": "cr", "název": "Kostarika" },
    // { "name": "Croacia", "code": "hr", "název": "Chorvatsko" },
    // { "name": "Cuba", "code": "cu", "název": "Kuba" },
    // { "name": "Chipre", "code": "cy", "název": "Kypr" },
    // { "name": "República Checa", "code": "cz", "název": "Česko" },
    // { "name": "Dinamarca", "code": "dk", "název": "Dánsko" },
    // { "name": "Yibuti", "code": "dj", "název": "Džibutsko" },
    // { "name": "Dominica", "code": "dm", "název": "Dominika" },
    // { "name": "República Dominicana", "code": "do", "název": "Dominikánská republika" },
    // { "name": "Ecuador", "code": "ec", "název": "Ekvádor" },
    // { "name": "Egipto", "code": "eg", "název": "Egypt" },
    // { "name": "El Salvador", "code": "sv", "název": "Salvador" },
    // { "name": "Guinea Ecuatorial", "code": "gq", "název": "Rovníková Guinea" },
    // { "name": "Eritrea", "code": "er", "název": "Eritrea" },
    // { "name": "Estonia", "code": "ee", "název": "Estonsko" },
    // { "name": "Etiopía", "code": "et", "název": "Etiopie" },
    // { "name": "Finlandia", "code": "fi", "název": "Finsko" },
    // { "name": "Francia", "code": "fr", "název": "Francie" },
    // { "name": "Alemania", "code": "de", "název": "Německo" },
    // { "name": "Ghana", "code": "gh", "název": "Ghana" },
    // { "name": "Grecia", "code": "gr", "název": "Řecko" },
    // { "name": "Honduras", "code": "hn", "název": "Honduras" },
    // { "name": "Hungría", "code": "hu", "název": "Maďarsko" },
    // { "name": "Islandia", "code": "is", "název": "Island" },
    // { "name": "India", "code": "in", "název": "Indie" },
    // { "name": "Indonesia", "code": "id", "název": "Indonésie" },
    // { "name": "Irán", "code": "ir", "název": "Írán" },
    // { "name": "Irak", "code": "iq", "název": "Irák" },
    // { "name": "Irlanda", "code": "ie", "název": "Irsko" },
    // { "name": "Israel", "code": "il", "název": "Izrael" },
    // { "name": "Italia", "code": "it", "název": "Itálie" },
    // { "name": "Japón", "code": "jp", "název": "Japonsko" },
    // { "name": "Jordania", "code": "jo", "název": "Jordánsko" },
    // { "name": "Kazajistán", "code": "kz", "název": "Kazachstán" },
    // { "name": "Kenia", "code": "ke", "název": "Keňa" },
    // { "name": "Kuwait", "code": "kw", "název": "Kuvajt" },
    // { "name": "Letonia", "code": "lv", "název": "Lotyšsko" },
    // { "name": "Líbano", "code": "lb", "název": "Libanon" },
    // { "name": "México", "code": "mx", "název": "Mexiko" },
    // { "name": "Marruecos", "code": "ma", "název": "Maroko" },
    // { "name": "Países Bajos", "code": "nl", "název": "Nizozemsko" },
    // { "name": "Nueva Zelanda", "code": "nz", "název": "Nový Zéland" },
    // { "name": "Nigeria", "code": "ng", "název": "Nigérie" },
    // { "name": "Noruega", "code": "no", "název": "Norsko" },
    // { "name": "Perú", "code": "pe", "název": "Peru" },
    // { "name": "Polonia", "code": "pl", "název": "Polsko" },
    // { "name": "Portugal", "code": "pt", "název": "Portugalsko" },
    // { "name": "Rusia", "code": "ru", "název": "Rusko" },
    // { "name": "Arabia Saudita", "code": "sa", "název": "Saúdská Arábie" },
    // { "name": "España", "code": "es", "název": "Španělsko" },
    // { "name": "Suecia", "code": "se", "název": "Švédsko" },
    // { "name": "Suiza", "code": "ch", "název": "Švýcarsko" },
    // { "name": "Turquía", "code": "tr", "název": "Turecko" },
    // { "name": "Ucrania", "code": "ua", "název": "Ukrajina" },
    // { "name": "Reino Unido", "code": "gb", "název": "Spojené království" },
    // { "name": "Estados Unidos", "code": "us", "název": "Spojené státy americké" }
]